<template>
    <div class="da-home">
    <div class="Home_box">
        <!-- 第一部分 -->
        <div class="songList_dan">
            <router-link to="/vocalist/13" class="tilte">{{$t("Homedata.tilte1")}} <span class="iconfont icon-youjiantou iconTu"></span></router-link>
            <div class="swiper-container" id="diyi">
                <div class="swiper-wrapper">
                    <div class="swiper-slide sde"  v-for="(item,index) in SongDanList" :key="index" @click="SongDan(item)">
                        <div class="flex-one">
                            <div class="cover">
                                <div class="cover-Mask">
                                    <img src="../../assets/imgbofang.png" alt="">
                                </div>
                                <img class="bei-tupian" :src="item.image" alt="">
                            </div>
                            <p class="cover-bottom-text">{{ item.content }}</p>
                            <p class="cover-bottom-textTwo">{{item.name}}</p>
                        </div>
                        
                    </div>
                </div>
                <!-- <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div> -->
            </div>
        </div>
        <!-- 第二部分 -->
        <div class="songList_name">
            <router-link to="/search" class="tilte">{{$t("Homedata.tilte2")}} <span class="iconfont icon-youjiantou iconTu"></span></router-link>
            <div class="swiper-container" id="dier">
                <div class="swiper-wrapper">
                    <div class="swiper-slide sde" v-for="(item,index) in SongName" :key="item.id">
                        <div class="flex-one"  @click="geshouXq(item)">
                            <div class="cover">
                                <div class="cover-Mask">
                                    <img src="../../assets/jianshi.png" alt="">
                                </div>
                                <img class="bei-tupian" :src="item.image" alt="">
                            </div>
                            <p class="cover-bottom-text">{{item.name}}</p>
                        </div>
                    </div>
                </div>
                <div style="left: auto !important; right:50px; z-index: 200;
                    position: absolute;" class="swiper-button-prev"></div><!--左箭头。如果放置在swiper外面，需要自定义样式。-->
                <div style="z-index: 200;position: absolute;" class="swiper-button-next"></div><!--右箭头。如果放置在swiper外面，需要自定义样式。-->
            </div>

        </div>
        <!-- 第三部分 -->
        <div class="fenti">
            <div class="l-tuijian">
                <router-link to="/classics" class="tilte">{{$t("Homedata.tilte3")}} <span class="iconfont icon-youjiantou iconTu"></span></router-link>
                <div class="fu-tilte">
                    <!-- <p class="songcover"></p> -->
                    <p class="songTlite" style="width: 440px;margin-left: 9px;"><span>{{$t("songList.songTilte")}}</span></p>
                    <p class="songzhuanji">{{$t("songList.zhuanji")}}</p>
                    <p class="songTime">{{$t("songList.shichang")}}</p>
                </div>
                <div class="song-dan" v-for="(item,index) in TuijianList" :key="index" @dblclick="DoubleClick(item)">
                    <div class="songcover"><img :src="item.music_image" alt=""></div>
                    <div class="songTlite">
                        <span style="
                        color: var(--them-L-nav-color);font-weight: 500;">{{item.names}} 
                            <!-- <img class="span_huiyuan" src="../../assets/huiyuan (2).png" alt=""> -->
                        </span>
                        <span style="font-weight: 500;">{{ item.name }}</span>
                    </div>
                    <div class="songzhuanji" style="color: var(--them-L-nav-color); font-weight: 500;">{{ item.zhuanji }}</div>
                    <div class="songTime" style="color: var(--them-L-nav-color); font-weight: 500">{{item.shijian}}</div>
                    <div class="songDian" @click="L_sanyuanbao(index)">•••</div>
                    <div class="Odang" :style="index>=5?{top:-170+'px'}:{top:15+'px'}" v-show="targetSpotone===index">
                        <!-- 内边距 -->
                        <div class="nei-bianju">
                            <div class="biao_img">
                                <img :src="item.music_image" alt="">
                                <div class="song-tc-text">
                                    <p>{{ item.names }}</p>
                                    <p>{{ item.name }}</p>
                                </div>
                            </div>
                            <div class="pop-bofang" @click="DoubleClick(item)">
                                <span class="icon iconfont icon-bofang"></span><p>播放</p>
                            </div>
                            <p style="border-top: solid 1px #e4e4e4; margin-top: 6px;margin-bottom: 6px;"></p>
                            <div class="pop-bofang" @click="$store.commit('changeSongId',item.id+1);">
                                <span class="icon iconfont icon-xiayishou" style="font-size: 20px;
                                  margin-left: 2px; margin-right: 2px;"></span><p>下一首</p>
                            </div>
                            <div class="pop-bofang" style="margin-top: 0;" @click="DownloadSong(item)">
                                <span class="icon iconfont icon-xiazai"  style="font-size: 14px; margin-left: 5px;"></span>
                                <img v-show="item.isnodown===1" style="position: absolute; bottom: 5px; width: 16px; left: 8px;" src="../../assets/xiaobiaoVIP.png" alt="">
                                <p>下载</p>
                            </div>
                            <div class="pop-bofang" style="margin-top: 0;" @click="FenXiangSong()">
                                <img class="icon" v-show="$store.state.ashen=='true'" style="width: 16px; height: 16px; font-size: 14px; margin-left: 5px;" src="../../assets/fenxiangHei.png" alt="">
                                <img class="icon" v-show="$store.state.ashen=='false'" style="width: 16px; height: 16px; font-size: 14px; margin-left: 5px;" src="../../assets/fenxiangBai.png" alt="">
                                <p>分享</p>
                            </div>
                        </div>
                    </div>
                    
                </div>
                
            </div>
            <div class="r-tuijian">
                <router-link to="/popular" class="tilte">{{$t("Homedata.tilte4")}} <span class="iconfont icon-youjiantou iconTu"></span></router-link>
                <div class="fu-tilte">
                    <!-- <p class="songcover"></p> -->
                    <p class="songTlite" style="width: 440px;margin-left: 9px;"><span>{{$t("songList.songTilte")}}</span></p>
                    <p class="songzhuanji">{{$t("songList.zhuanji")}}</p>
                    <p class="songTime">{{$t("songList.shichang")}}</p>
                </div>
                <div class="song-dan" v-for="(item,index) in ReMenList" :key="index" @dblclick="DoubleClick(item)">
                    <div class="songcover"><img :src="item.music_image" alt=""></div>
                    <div class="songTlite">
                        <span style="color: var(--them-L-nav-color);font-weight: 500;">{{ item.names }} 
                            <!-- <img class="span_huiyuan" src="../../assets/huiyuan (2).png" alt=""> -->
                        </span>
                        <span style="font-weight: 500;">{{ item.name }}</span>
                    </div>
                    <div class="songzhuanji" style="color: var(--them-L-nav-color); font-weight: 500;">{{item.zhuanji}}</div>
                    <div class="songTime" style="color: var(--them-L-nav-color); font-weight: 500">{{ item.shijian }}</div>
                    <div class="songDian" @click="R_sanyuanbao(index)">•••</div>
                    <div class="Odang" :style="index>=5?{top:-170+'px'}:{top:15+'px'}" v-show="targetSpotTwo===index">
                        <!-- 内边距 -->
                        <div class="nei-bianju">
                            <div class="biao_img">
                                <img :src="item.music_image" alt="">
                                <div class="song-tc-text">
                                    <p class="">{{ item.names }}</p>
                                    <p>{{ item.name }}</p>
                                </div>
                            </div>
                            <div class="pop-bofang" @click="DoubleClick(item)">
                                <span class="icon iconfont icon-bofang"></span><p>播放</p>
                            </div>
                            <p style="border-top: solid 1px #e4e4e4; margin-top: 6px;margin-bottom: 6px;"></p>
                            <div class="pop-bofang" @click="$store.commit('changeSongId',item.id+1);">
                                <span class="icon iconfont icon-xiayishou" style="font-size: 20px;
                                  margin-left: 2px; margin-right: 2px;"></span><p>下一首</p>
                            </div>
                            <div class="pop-bofang" style="margin-top: 0;" @click="DownloadSong(item)">
                                <span class="icon iconfont icon-xiazai"  style="font-size: 14px;
                                 margin-left: 5px;"></span>
                                 <img v-show="item.isnodown===1" style="position: absolute; bottom: 5px; width: 16px; left: 8px;" src="../../assets/xiaobiaoVIP.png" alt="">
                                 <p>下载</p>
                            </div>
                            <div class="pop-bofang" style="margin-top: 0;" @click="FenXiangSong()">
                                <img class="icon" v-show="$store.state.ashen=='true'" style="width: 16px; height: 16px; font-size: 14px; margin-left: 5px;" src="../../assets/fenxiangHei.png" alt="">
                                <img class="icon" v-show="$store.state.ashen=='false'" style="width: 16px; height: 16px; font-size: 14px; margin-left: 5px;" src="../../assets/fenxiangBai.png" alt="">
                                <p>分享</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部信息 -->
        <div class="bottom_xinxi">
            <div>
                <p style="font-size: 18px; font-family: YuanTi; font-weight: bold; margin-top: 25px; color: var(--them-color);">{{$t('Homedata.shezhi1')}}</p>
                <p style="font-size: 14px;font-family: YuanTi; margin-top: 5px; color: var(--them-color);">{{$t('Homedata.shezhi2')}}</p>
            </div>
        </div>
        <!-- 公司信息 -->
        <div class="Gong_si_xinxi">
            <p class="gs_p">北京酷皮科技有限公司</p>
            <a href="https://beian.miit.gov.cn/" target="_blank" class="gs_p">京ICP备2021002022号-4</a>
            <p class="gs_p">地址：北京市朝阳区安贞西里五区一号五层518</p>
            
            <p class="gs_p" ><img src="../../assets/Dianhua.png" alt="">010-87922370</p>
            <p class="gs_p" ><img src="../../assets/Youxian.png" alt="">huzhijian@coolpi360.com</p>
            
        </div>
        <div class="Gong_si_xinxi" style="margin-top: 5px;">
            <a href="/img/yyzz.png" target="_blank" class="gs_p">营业执照</a>
            <router-link class="gs_p" to="/report">涉青少年举报</router-link>
            <!-- <router-link class="gs_p" to="/yinsi">用户协议</router-link>
            <router-link class="gs_p" to="/xieyi">隐私政策</router-link> -->
            <router-link class="gs_p" to="/weicheng">未成年人保护制度</router-link>
            <a href="https://www.12377.cn/index.html" target="_blank" class="gs_p">违法和不良信息举报中心</a>
        </div>
        <div class="YouqingLianjie">
            <p class="gs_p">友情链接 : </p>
            <a href="https://www.xlebbs.com/" target="_blank" class="gs_p">享乐音乐论坛 &nbsp;|</a>
            <a href="https://music.91q.com/" target="_blank" class="gs_p">千千音乐 &nbsp;|</a>
            <a href="https://www.yinyuetai.com/" target="_blank" class="gs_p">音悦网 &nbsp;|</a>
            <a href="http://www.1ting.com/" target="_blank" class="gs_p">一听音乐 &nbsp;|</a>
            <a href="https://suno.dljcchb2.cn/h5/suno-v/index.html?self_os=1&platform_id=24&app_id=1186&agency_id=162&channel_id=18166&qhclickid=88c8bf835969138d#/" target="_blank" class="gs_p">
                Suno 写歌 &nbsp;|
            </a>
            <a href="http://www.doupi360.com/" target="_blank" class="gs_p">
                豆皮
            </a>
        </div>
    </div>
        <div class="SetOff" v-show="songPop" @click="CloseAll()"></div>
    </div>
</template>

<script>
import Swiper from 'swiper'
import axios from 'axios';
import 'swiper/css/swiper.min.css'
import request from '@/request';
    export default {
        name:'Home',
        data(){
            return{
                songPop:false,//控制 SetOff 弹窗的总 关闭！false 关闭 true 开启
                targetSpotone:-1,//当用户 点击左边 三个点的下标值
                targetSpotTwo:-1,//当用户 点击右边 三个点的小标值
                list:[{text:1},{text:2},{text:3},{text:4},{text:5},{text:6},{text:7},{text:8}],
                SongName:[],//歌手
                SongDanList:[],//歌单
                TuijianList:[],//推荐歌单
                ReMenList:[],//热门歌单
                //测试歌曲
                ceshi:{
                    name:'把回忆拼好给你',
                    img:'https://www.zhaogeci.net/d/file/img/album/138371527.jpg',
                    audio_src:require('../../assets/1593859705.mp3'),// 比加require('../../mius') 不然会报错 找不到资源 
                    content:"[ti:把回忆拼好给你-cici_.128][ar:戴立志][al:把回忆拼好给你(新版)][by:krc转qrc工具][offset:0][00:00.00]戴立志 - 把回忆拼好给你-cici_.128[00:00.53]词：童子-T、Shingo.S[00:00.89]曲：童子-T[00:01.03]独自收集两个人之间的回忆[00:04.49]即使每当到这时候我都会哭泣[00:07.99]为何一切[00:09.69]变得如此[00:11.38]无法回到过去[00:21.26]我们都是渺小真实存在[00:24.38]祈愿小世界里不只有挫败[00:27.61]直到遇见你我以为就光明起来[00:30.83]眼睛里看到的都是广袤无垠的大海[00:34.42]有你在的日子里不可能被取代[00:37.64]在最灰暗的日子你陪着我发呆[00:40.87]你让我学会如何拨开阴霾[00:43.62]将快乐全部收集将不开心全都淘汰[00:46.43]你对我说的情话[00:49.36]像转瞬即逝的烟花[00:52.59]只停在绽放一刹那[00:55.77]我却已无法自拔[00:58.97]我们的爱总有时差[01:02.20]也为你骗自己放下[01:05.35]爱炙热的你却忘了爱自己[01:12.79]和你在一起画面一帧帧唤醒脑海[01:16.04]你总说我是小孩对我总是想溺爱[01:19.26]我像做了一场梦梦见我们的未来[01:22.45]我们俩嬉嬉闹闹直到梦突然醒来[01:25.64]想和你说声谢谢至少笑着离开[01:28.62]不想闹的不愉快互相不理不睬[01:32.06]我想说爱这件事总要履行告白[01:35.26]最后就用朋友身份说拜拜[01:51.26]有你在的日子里不可能被取代[01:54.43]在最灰暗的日子你陪着我发呆[01:57.70]你让我学会如何拨开阴霾[02:00.42]将快乐全部收集将不开心全都淘汰[02:03.25]你对我说的情话[02:06.14]像转瞬即逝的烟花[02:09.38]只停在绽放一刹那[02:12.58]我却已无法自拔[02:15.83]我们的爱总有时差[02:19.01]也为你骗自己放下[02:22.23]爱炙热的你却忘了爱自己[02:29.07]独自收集两个人之间的回忆[02:32.25]即使每当到这时候我都会哭泣[02:35.43]为何一切[02:37.04]变得如此[02:38.60]无法回到过去[02:41.80]但我仍愿意感谢你给过我爱情[02:45.03]每一场风景都是我们爱的证明[02:48.22]就算如今天各一方[02:51.41]祝你余生动听啊[02:54.24]你对我说的情话[02:57.34]像转瞬即逝的烟花[03:00.57]只停在绽放一刹那[03:03.80]我早已无法自拔[03:06.98]我们的爱总有时差[03:10.20]也为你骗自己放下[03:13.44]爱炙热的你却忘了爱自己"
                },
            }
        },
        
        mounted(){
            this.getLoadingOk();//请求数据
        },
        methods:{
            //@dblclick 双击事件
            //页面加载完成执行--求情数据
            async getLoadingOk(){
                const [isSucess,data] =  await request({
                    url:'api/index/singer',
                });
                if(isSucess){
                    // console.log(data)
                    this.SongName = data.data;
                    // console.log(this.SongName);
                    this.$nextTick(()=>{
                        new Swiper('#dier', {
                            slidesPerView: 8,
                            grid: {
                                fill: 'column',
                                rows: 1,
                            },
                            navigation: {
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev',
                            },
                            
                        });
                    })
                    
                }
                //歌单请求 定义请求的数据
                //歌曲
                axios.post('api/index/gedan')
                .then(response => {
                    // 处理请求成功的响应
                    // console.log(response.data);
                    this.SongDanList = response.data.data;
                    this.$nextTick(()=>{
                        new Swiper('#diyi', {
                            // loop: true, // 循环模式选项
                           
                            slidesPerView: 8,//分类显示8个
                            grid: {//设置网格布局
                                fill: 'column',//竖向 排列
                                rows: 1, //走1个
                            },

                        });
                    });
                   
                })
                .catch(error => {
                    // 处理请求失败的错误
                    console.error(error);
                });

                //单曲推荐
                axios.post('api/index/tuijian')
                .then(response => {
                    // 处理请求成功的响应
                    // console.log(response.data);
                    this.TuijianList = response.data.data;
                })
                .catch(error => {
                    // 处理请求失败的错误
                    console.error(error);
                });

                //热门歌曲
                axios.post('api/index/hot')
                .then(response => {
                    // 处理请求成功的响应
                    // console.log(response.data);
                    this.ReMenList = response.data.data;
                })
                .catch(error => {
                    // 处理请求失败的错误
                    console.error(error);
                });

            },
            //关闭列表的小弹窗
            //双击播放
            DoubleClick(item){
                console.log('双击播放！',item.id)
                this.$store.commit('changeSongId',item.id);
            },
            CloseAll(){
                console.log('关闭所有!');
                if(this.targetSpotone!==-1 || this.targetSpotTwo!==-1){
                    this.targetSpotone = -1;
                    this.targetSpotTwo = -1;
                    this.songPop = false;
                }else{
                    this.songPop = true;
                }
            },
            //三个点 左边
            L_sanyuanbao(index){
                this.targetSpotone = index;
                this.songPop = true;
            },
            //三个点 右边
            R_sanyuanbao(index){
                this.targetSpotTwo = index;
                this.songPop = true;
            },
            //跳转歌手详情
            geshouXq(item){
                console.log(item);
                this.$router.push(`vocalist/${item.id}`);
            },
            //歌单 跳转信息
            SongDan(item){
                this.$router.push(`vocalist/${item.id}`);
            },
            //下载歌曲
            DownloadSong(item){
                console.log(item);
                if(this.$store.state.LoginStatus!==''){//判断用户是否登录 !==''是 ''不是
                    if(item.isnodown==1){//判断歌曲是否是会员 1是 0不是
                        if(this.$store.state.LoginStatus.isnovip==2){//判断用户是否是vip 2是 1不是
                            this.$store.commit('DownloadSongs',item);
                        }else{
                            this.$message.warning('你还不是vip用户，请充值成为vip用户！');
                        }
                    }else{
                        this.$store.commit('DownloadSongs',item);
                    }
                    
                }else{
                    this.$message.warning('请先登录');
                }
               
                
            },
            //分享
            FenXiangSong(){
                navigator.clipboard.writeText('https://www.mosichat.com/#/')
                .then(() => this.$message.success('歌曲链接已复制到剪贴板，快分享给朋友们吧'))
                .catch(()=> this.$message.error('歌曲链接复制失败，请手动复制'));
            }
        }
    }

</script>
<style scoped lang="scss">
    .da-home{
        position: relative;
    }
    .Home_box{
        width:83%;
        overflow: hidden;
        margin: 0 auto;
        padding-top: 10px;
        padding-bottom: 30px;
        .songList_dan{
            width: 100%;
            height: 270px;
            border-bottom:solid 1px var(--Home-dan-border);
            margin-bottom: 30px;
            .swiper-container{
                width: 100%;
                height: 210px;
                margin-top: 13px;
                //设置swiper 样式
                // --swiper-theme-color: #ff6600;/* 设置Swiper风格 */
                --swiper-navigation-color: var(--them-T-nav-tuiHui-color);/* 单独设置按钮颜色 */
                --swiper-navigation-size:13px;/* 设置按钮大小 */
                position: relative;
                .swiper-button-prev,.swiper-button-next{
                    width: 35px;
                    height: 35px;
                    background-color: var(--them-T-nav-tuiHui-background);
                    border-radius: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    opacity: 0.7;
                    
                    background-color: rgb(255, 0, 170);
                }
                .swiper-button-prev:hover{
                    background-color: var(--theme-hover-background);
                    z-index: 99;
                    opacity:1;
                }
                .swiper-button-next:hover{
                    background-color: var(--theme-hover-background);
                    z-index: 99;
                    opacity: 1;
                }
                // 轮播图内容
                .swiper-wrapper{
                    .sde{
                        width: 100%;
                        height: 100%;
                        // background-color: blanchedalmond;
                        display: grid;
                        grid-template-columns:1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr ;//这是将网格分为几列，1fr是自适配单位，可以当成栅格
                        overflow: hidden;
                        
                        gap:25px;
                        // 多个内容
                        .flex-one{
                            width: 150px;
                            height: 100%;
                            // background-color: aqua;
                            display: flex;
                            flex-direction: column;
                            //封面图
                            .cover{
                                width: 100%;
                                height: 150px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                // background-color: aquamarine;
                                overflow: hidden;
                                border-radius: 12px;
                                cursor: pointer;
                                position: relative;
                                .cover-Mask{
                                    position: absolute;
                                    width: 100%;
                                    height: 100%;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    background-color: rgba(0,0,0,0.3);
                                    z-index: 1;
                                    transition: 0.3s;
                                    opacity: 0;
                                    img{
                                        transition: 0.2s;
                                        width: 12%;
                                        height:12%;
                                    }
                                }

                                .bei-tupian{
                                    position: absolute;
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                    z-index: 0;
                                }
                            }
                            .cover:hover .cover-Mask{
                                transition: 0.3s;
                                opacity: 1;
                                img{
                                    transition: 0.2s;
                                    width:17%;
                                    height:17%;
                                }
                            }
                            // 封面下面的文字标题
                            .cover-bottom-text{
                                width: 100%;
                                font-size: var(--nav-songTlite-fsize);
                                font-family: YuanTi;
                                // font-weight: bold;
                                margin-top: 5px;
                                color: var(--them-L-nav-color);
                                word-break: break-all;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 1; /* 超出几行省略 */
                                overflow: hidden;
                                cursor: pointer;
                            }
                            .cover-bottom-textTwo{
                                cursor: pointer;
                                width: 100%;
                                font-size: var(--nav-text-fsize12);
                                font-family: YuanTi;
                                // font-weight: bold;
                                margin-top: 5px;
                                color: var(--them-song-text-color);
                                word-break: break-all;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 1; /* 超出几行省略 */
                                overflow: hidden;
                            }
                        }
                    }
                }
            } 
        }
        // 第二部分
        .songList_name{
            width: 100%;
            height: 240px;
            overflow: hidden;
            padding-bottom: 12px;
            border-bottom:solid 1px var(--Home-dan-border);
            position: relative;
            .tilte{
                font-size: 20px;
                font-family: YuanTi;
                font-weight: bold;
                cursor: pointer;
                color: var(--them-color);
                position: absolute;
                z-index: 2;
                .iconTu{
                    font-size: 12px;
                    font-weight:100;
                    font-weight: bold;
                    color: var(--them-L-nav-color);
                }
            }
            .swiper-container{
                width: 100%;
                height: 270px;
                position: absolute;
                //设置swiper 样式
                // --swiper-theme-color: #ff6600;/* 设置Swiper风格 */
                --swiper-navigation-color: var(--them-T-nav-tuiHui-color);/* 单独设置按钮颜色 */
                --swiper-navigation-size:13px;/* 设置按钮大小 */
                position: relative;
                .swiper-button-prev,.swiper-button-next{
                    width: 35px;
                    height: 35px;
                    background-color: var(--them-T-nav-tuiHui-background);
                    border-radius: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    opacity: 0.7;
                   top: 10px;
                   right: 0;
                   z-index: 100;
                   position: absolute;
                }
                .swiper-button-prev:hover{
                    background-color: var(--theme-hover-background);
                    z-index: 3;
                    opacity:1;
                }
                .swiper-button-next:hover{
                    background-color: var(--theme-hover-background);
                    z-index: 3;
                    opacity: 1;
                }
                // 轮播图内容
                .swiper-wrapper{
                    .sde{
                        width: 100%;
                        height: 100%;
                        // background-color: blanchedalmond;
                       display: flex;
                       align-items: center;
                       justify-content: space-between;
                        // background-color: aqua;
                        gap:25px;
                        // 多个内容
                        .flex-one{
                            width: 150px;
                            height: 100%;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            margin-top: 100px;
                            // background-color: rgb(47, 0, 255);
                            //封面图
                            .cover{
                                width: 100%;
                                height: 150px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                border: solid 1px var(--them-background);
                                overflow: hidden;
                                border-radius:50%;
                                cursor: pointer;
                                position: relative;
                                .cover-Mask{
                                    position: absolute;
                                    width: 100%;
                                    height: 100%;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    background-color: rgba(0,0,0,0.3);
                                    z-index: 1;
                                    transition: 0.3s;
                                    opacity: 0;
                                    img{
                                        transition: 0.2s;
                                        width: 12%;
                                        height:12%;
                                    }
                                }

                                .bei-tupian{
                                    position: absolute;
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                    z-index: 0;
                                }
                            }
                            .cover:hover .cover-Mask{
                                transition: 0.3s;
                                opacity: 1;
                                img{
                                    transition: 0.2s;
                                    width:19%;
                                    height:19%;
                                }
                            }
                            // 封面下面的文字标题
                            .cover-bottom-text{
                                font-size: var(--nav-text-fsize15);
                                font-family: YuanTi;
                                // font-weight: bold;
                                margin-top: 10px;
                                color: var(--them-L-nav-color);
                            }
                            .cover-bottom-textTwo{
                                width: 100%;
                                font-size: var(--nav-text-fsize);
                                font-family: YuanTi;
                                font-weight: bold;
                                margin-top: 5px;
                                color: var(--them-song-text-color);
                            }
                        }
                    }
                }
            } 
        }
        // 第三部分 左右结构
        .fenti{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 30px;
            border-bottom: solid 1px var(--Home-dan-border);
            padding-bottom: 15px;
            .fu-tilte{
                width: 100%;
                height: 49px;
                display: flex;
                align-items: center;
                border-radius: 5px;
                margin-top: 6px;
            }
            .song-dan{
                width: 100%;
                height: 47px;
                display: flex;
                align-items: center;
                border-radius: 8px;
                transition: 0.2s;
                margin-bottom: 5px;
                position: relative;
            }
            .song-dan:hover{
                transition: 0.2s;
                cursor: pointer;
                background-color: var(--them-L-nav-background);
            }
        }
        .Gong_si_xinxi{
            width: 100%;
            height: 20px;
            // background-color: aqua;
            margin-top: 20px;
            .gs_p{
                font-size: 14px;
                color: #6f6f6f;
                margin-right: 13px;
                margin-bottom: 5px;
                color: var(--fubiaoti);
                font-family: YuanTi;
                display: flex;
                align-items: center;
                float:left;
                img{
                    width:20px;
                    margin-right: 3px;
                }
            }
        }
        .YouqingLianjie{
            width: 100%;
            height: 20px;
            // background-color: aqua;
            display:flex;
            align-items: center;
            .gs_p{
                margin-right: 15px;
                font-size: 13px;
                color: #6f6f6f;
                margin-right: 8px;
                color: var(--fubiaoti);
                font-family: YuanTi;
            }
        }
    }
    // 公用标题
            .tilte{
                font-size: 20px;
                font-family:YuanTi;
                font-weight: bold;
                // font-style: italic;
                cursor: pointer;
                color: var(--them-color);
                .iconTu{
                    font-size: 12px;
                    font-weight:100;
                    font-weight: bold;
                    color: var(--them-L-nav-color);
                }
            }
            .songcover{
                width: 33px;
                height: 33px;
                border-radius: 5px;
                // background-color: aqua;
                margin-left: 8px;
                margin-right: 8px;
                overflow: hidden;
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            .songTlite{
                width: 400px;
                height: 45px;
                display: flex;
                flex-direction: column;
                justify-content: space-evenly;
                
                span:nth-child(1){
                    font-size: var(--nav-songTlite-fsize);
                    font-weight: bold;
                    font-family: YuanTi;
                    color: var(--nav-song-color);
                    display: flex;
                    align-items: flex-end;
                }
                span:nth-child(2){
                    font-size: var(--nav-text-fsize12);
                    color: var(--nav-song-name-color);
                    font-weight: bold;
                }
            }
            .songzhuanji{
                width: 100px;
                height: 49px;
                margin-right: 15px;
                line-height: 49px;
                font-size: var(--nav-songTlite-fsize);
                font-weight: bold;
                font-family: YuanTi;
                color: var(--nav-song-color);
                word-break: break-all;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1; /* 超出几行省略 */
                overflow: hidden;
            }
            .songTime{
                width: 60px;
                height: 49px;
                line-height: 49px;
                font-size: var(--nav-songTlite-fsize);
                font-weight: bold;
                font-family: YuanTi;
                color: var(--nav-song-color);
            }
            .songDian{
                width: 30px;
                height: 30px;
                text-align: center;
                line-height: 30px;
                margin-right: 5px;
                font-size: 12px;
                color: var(--them-color);
                border-radius: 30px;
            }
            .songDian:hover{
                background-color: var(--hover-background);
            }
            .Odang{
                position: absolute;
                right: 19px;
                width: 250px;
                height: 232px;
                border-radius: 15px;
                z-index: 100;
                background-color: var(--tc-background);
                border: solid 1px var(--border);
                backdrop-filter: blur(5px);
                top: 15px;
                display: flex;
                align-items: center;
                justify-content: center;
                .nei-bianju{
                    width: 230px;
                    height: 215px;
                    // background-color: aqua;
                    border-radius: 10px;
                    .biao_img{
                        width: 100%;
                        height: 55px;
                        border-bottom: solid 1px #e4e4e4;
                        display: flex;
                        img{
                            width: 45px;
                            height: 45px;
                            border-radius: 8px;
                            object-fit: cover;
                            overflow: hidden;
                        }
                        .song-tc-text{
                            margin-left: 7px;
                            height: 40px;
                            display: flex;
                            flex-direction:column;
                            justify-content: space-between;
                            p:nth-child(1){
                                font-size: 13px;
                                font-family: YuanTi;
                                color:var(--them-color);
                            }
                            p:nth-child(2){
                                font-size: 12px;
                                font-family: YuanTi;
                                color:var(--fubiaoti);
                            }
                        }
                    }
                    .pop-bofang{
                        display: flex;
                        align-items:center;
                        margin-top: 5px;
                        height: 35px;
                        // border-bottom: solid 1px #e4e4e4;
                        position: relative;
                        border-radius: 5px;
                        .icon{
                            font-size: 15px;
                            margin-right: 6px;
                            margin-left: 5px;
                            color: var(--them-color);
                        }
                        p{
                            font-size: 13px;
                            font-family:YuanTi;
                            color: var(--them-color);
                        }
                    }
                    .pop-bofang:hover{
                        background-color: var(--hover-background);
                    }
                }
            }
            .SetOff{
                width: 100vw;
                height: 100%;
                z-index: 99;
                position: absolute;
                top: 0;
            }
            .span_huiyuan{
                width: 15px;
                height: 15px;
                margin-left: 5px;
            }
            .bottom_xinxi{
                width: 100%;
                display: flex;
                align-items: center;
                justify-content:space-between;
            }
</style>